import React, { useEffect, useState } from "react";
import Modal from "@/components/ui/modal";
import Input from "@/components/ui/input";

interface Props {
  isOpen: boolean;
  loading?: boolean;
  initial?: { name: string; description?: string | null } | null;
  onClose: () => void;
  onSubmit: (payload: { name: string; description?: string }) => void;
}

const CreateGroupModal: React.FC<Props> = ({ isOpen, loading, initial, onClose, onSubmit }) => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    setName(initial?.name ?? "");
    setDescription(initial?.description ?? "");
  }, [initial, isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={initial ? "Grubu Düzenle" : "Yeni Grup"}
      withForm
      loading={loading}
      handleSubmit={(e) => {
        e.preventDefault();
        onSubmit({ name: name.trim(), description: description.trim() || undefined });
      }}
      isFormValid={name.trim().length > 0}
    >
      <div style={{ display: "grid", gap: 12 }}>
        <Input label="Grup Adı" value={name} onChange={(e) => setName(e.target.value)} />
        <Input label="Açıklama" value={description} onChange={(e) => setDescription(e.target.value)} />
      </div>
    </Modal>
  );
};

export default CreateGroupModal;
